import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';
import { cp } from './cp';

import cView from './cView';

export default class cOrgDtl extends cView {

  $id_stgs = {
  };

  $cd_stss = {
    sld_cm10ss: [], // 社員
    sld_cm31ss: [], // 所属者
  };

  $clp_bfrLoads = () => [
    cp.$cp_hlr_cm10({ // 検索用社員
      mode: 'items',
      state: 'sld_cm10ss',
      cnd: bf.q('[cm10b21k]="{}" AND IFNULL([cm10cz10], "10")<>"0"'.f(global.c?.state.sgcd_pagePntKeys.cm20_key))
    }),
  ];

  $clp_loads = () => [
    new Promise( _o_end1 => {
      global.c?.setState({
        sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
          _next.cm30_key = global.c?.state.sgc_pageKey;
        }),
      }, () => {
        _o_end1();
      });
    }),
    cp.$cp_hlr_cm30({ // 表示用部門
      mode: 'set',
      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
      cnd: bf.q(`
        [_KEY]={}
      `.f(
        global.c?.state.sgc_pageKey
      ))
    }),
    cp.$cp_hlr_cm31({ // 所属者
      mode: 'clds',
      state: 'sld_cm31ss',
//      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
      cnd: bf.q(`
        [cm31b21k]="{}" AND 
        IFNULL([cm31cz10], "10")<>"0"
      `.f(global.c?.state.sgc_pageKey))
    }),
  ];

  $cp_ins = () => new Promise( _o_end1 => {
    cp.$cp_hlr_cm30({
      mode: 'ins',
    })
    .then( _d_is => {
      global.c?.setState({
        sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
          _next.cm30_key = _d_is._KEY;
        }),
      }, () => {
        _o_end1(_d_is);
      });
    });
  });

  $clp_upds = () => [
    cp.$cp_hlr_cm30({
      mode: 'upd',
      cnd: bf.q('[_KEY]={}'.f(global.c?.state.sgc_pageKey))
    }),
    cp.$cp_hlr_cm31({
      mode: 'iudClds',
      state: 'sld_cm31ss',
    }),
/*
    new Promise( _o_end1 => {
      global.c?.state.sld_cm31ss
      .map( _d_is => {
bf.l('{}'.f(_d_is));
        if ( _d_is.b_dlt == true ) {
          if ( String(_d_is).substr(3) != 'new') {
          }
          if ( String(_d_is).substr(3) == 'new') {
            // 処理なし
          }
        };
        if ( _d_is.b_ups == true ) {
          if ( String(_d_is).substr(3) != 'new') {
          }
          if ( String(_d_is).substr(3) == 'new') {
          }
        };
      });
      _o_end1();
    }),
*/

  ];

}
